export const SET_CONTACT_PROPERTY_HISTORY = 'SET_CONTACT_PROPERTY_HISTORY'
export const RESET_CONTACT_PROPERTY_HISTORY = 'RESET_CONTACT_PROPERTY_HISTORY'
